import React, { Fragment } from "react"
import "styles/components/common/loader.scss"
import cx from "classnames"

import LoaderLogo from "assets/icons/loader-logo.svg"

const PageLoader = ({ loading }) => {
  const schoolLogo = localStorage.getItem("schoolLogo")
  return (
    <Fragment>
      {Boolean(loading) && (
        <div className="overlay-loader">
          <img
            src={schoolLogo || LoaderLogo}
            alt="apptitude"
            className="image-loader"
          />
        </div>
      )}
    </Fragment>
  )
}

const ContentLoader = ({ loading }) => {
  return <div className={cx("loading-container", { loading: loading })} />
}

export { PageLoader, ContentLoader }
